'use strict';

var React = require('react');

/**
 * @public
 */
const MotionConfigContext = React.createContext({
    transformPagePoint: (p) => p,
    isStatic: false,
    reducedMotion: "never",
});

exports.MotionConfigContext = MotionConfigContext;
//# sourceMappingURL=MotionConfigContext.cjs.map
